import axios from 'axios';

const TIMEOUT = 15000;

const startFullApplication = async (transactionId: string) => {
    const url = `${process.env.REACT_APP_START_FULL_APPLICATION_URL}/${transactionId}`;
    return axios.post(url, {}, {
        validateStatus: (status => status === 200),
        timeout: TIMEOUT,
    });
}

export { startFullApplication };